import * as CookieConsent from "vanilla-cookieconsent";
import type { CookieConsentConfig } from "vanilla-cookieconsent";

const getConfig = (): CookieConsentConfig => ({
  root: "body",
  autoShow: true,
  disablePageInteraction: false,
  hideFromBots: import.meta.env.PROD,
  mode: "opt-in",
  revision: 2,

  cookie: {
    name: "cc_cookie",
    domain: location.hostname,
    path: "/",
    sameSite: "Lax",
    expiresAfterDays: 365,
  },

  guiOptions: {
    consentModal: {
      layout: "box",
      position: "bottom right",
      equalWeightButtons: true,
      flipButtons: false,
    },
  },

  onConsent: () => {},
  onChange: () => {},

  categories: {
    necessary: {
      enabled: true,
      readOnly: true,
    },
  },

  language: {
    default: "fr",
    translations: {
      fr: {
        consentModal: {
          title: "Nous utilisons des cookies",
          description:
            "Nous utilisons uniquement des cookies strictement nécessaires au fonctionnement de l'application (session, authentification).",
          acceptAllBtn: "Accepter",
          acceptNecessaryBtn: "Fermer",
          showPreferencesBtn: "En savoir plus",
          footer: `
            <a href="/privacy" target="_blank">Politique de confidentialité</a>
            <a href="/terms" target="_blank">CGU</a>
          `,
        },
        preferencesModal: {
          title: "Préférences cookies",
          acceptAllBtn: "Accepter",
          acceptNecessaryBtn: "Fermer",
          savePreferencesBtn: "Enregistrer",
          closeIconLabel: "Fermer",
          sections: [
            {
              title: "Cookies strictement nécessaires",
              description:
                "Ces cookies sont indispensables au fonctionnement du site (session, authentification). Ils ne peuvent pas être désactivés.",
              linkedCategory: "necessary",
            },
          ],
        },
      },
      en: {
        consentModal: {
          title: "We use cookies",
          description:
            "We only use strictly necessary cookies for the application to work (session, authentication).",
          acceptAllBtn: "Accept",
          acceptNecessaryBtn: "Close",
          showPreferencesBtn: "Learn more",
          footer: `
            <a href="/privacy" target="_blank">Privacy Policy</a>
            <a href="/terms" target="_blank">Terms of Service</a>
          `,
        },
        preferencesModal: {
          title: "Cookie preferences",
          acceptAllBtn: "Accept",
          acceptNecessaryBtn: "Close",
          savePreferencesBtn: "Save preferences",
          closeIconLabel: "Close",
          sections: [
            {
              title: "Strictly necessary cookies",
              description:
                "These cookies are required for the website to function (session, authentication). They cannot be disabled.",
              linkedCategory: "necessary",
            },
          ],
        },
      },
    },
  },
});

export default getConfig;
